var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsMarking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.0098C13.5427 7.0098 14.8067 8.21459 14.8951 9.73913L14.9 9.9498C14.9 11.5469 13.597 12.8498 12 12.8498C10.453 12.8498 9.19293 11.6408 9.1049 10.12L9.09999 9.9098C9.09999 8.36014 10.3022 7.10255 11.8291 7.0147L12 7.0098ZM12 8.8098C11.4279 8.8098 10.9655 9.23408 10.9064 9.78899L10.899 9.9298L10.9 9.9498C10.9 10.5164 11.3279 10.9836 11.8799 11.0433L12 11.0498C12.5627 11.0498 13.0332 10.6168 13.0935 10.0689L13.1 9.9498V9.9098C13.1 9.301 12.6071 8.8098 12 8.8098Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.99 2.0918L11.7387 2.0959C7.62837 2.23456 4.35332 5.53306 4.22396 9.61399L4.22034 9.90884C4.21616 9.94626 4.21399 9.98492 4.21399 10.0248C4.21399 12.6916 6.21195 16.0694 9.11986 19.5676L9.69375 20.2461C9.98609 20.5859 10.2863 20.9264 10.5934 21.2672C11.3407 22.0934 12.6313 22.0934 13.3786 21.2694C17.0647 17.1784 19.76 13.124 19.76 10.0348V9.8648C19.76 5.57324 16.2785 2.0918 11.99 2.0918ZM11.7843 3.89526L11.99 3.8918C15.2844 3.8918 17.96 6.56735 17.96 9.8648V10.0348C17.96 11.8541 16.5442 14.4516 14.4424 17.1918L13.9455 17.8264C13.6066 18.2508 13.2527 18.6774 12.8866 19.1039L12.3286 19.7433C12.2342 19.8497 12.1391 19.9561 12.0434 20.0624C12.0127 20.0962 11.9612 20.0962 11.9294 20.061L11.6441 19.7419L11.363 19.4223L10.8139 18.7826C10.724 18.676 10.6348 18.5694 10.5466 18.4629L10.0274 17.8249C7.73984 14.96 6.13215 12.1952 6.02023 10.2388L6.01599 10.1058L6.01999 10.0448V9.8648C6.01999 6.64029 8.57434 4.00364 11.7843 3.89526Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsMarking);
export default __webpack_public_path__ + "static/media/icons-marking.f1f2a30fe62956ada38e1c1fb98dfcb2.svg";
export { ForwardRef as ReactComponent };